module.exports = function getResource(label, vars = []) {
    let resources = {
        subscribeLabel: 'S’abonner aux courriels de Sephora',
        popoverContent: 'Sephora Beauty Canada, Inc. (600 Boulevard de Maisonneuve Ouest, Suite 2400, Montréal, Québec, H3A 3J2, sephora.ca) demande le consentement en son propre nom et au nom de Sephora USA, Inc. (525, Market Street, Floor 32, San Francisco, CA 94105, sephora.com). Vous pouvez retirer votre consentement en tout temps.'
    };
    return resources[label];
};
